import {
	ApiAssignmentMoveValidDateRangeResponse,
	ApiDateRange,
	ApiValidationPhaseError,
	ApiValidationPhaseResponse,
} from '../api-types/validation.api';
import {
	AssignmentMoveValidDateRangeResponse,
	DateRange,
	ValidationPhaseError,
	ValidationPhaseResponse,
} from '../app-types/validation.app';

export const transformApiValidationPhaseResponseToApp = (
	input: ApiValidationPhaseResponse,
): ValidationPhaseResponse => {
	const output: ValidationPhaseResponse = {
		...input,
	};
	return output;
};

export const transformValidationPhaseErrorApiToApp = (input: ApiValidationPhaseError): ValidationPhaseError => {
	return {
		...input,
	};
};

export const transformValidationPhaseResponseToApi = (input: ValidationPhaseResponse): ApiValidationPhaseResponse => {
	const output: ApiValidationPhaseResponse = {
		...input,
	};
	return output;
};

export const transformValidationPhaseErrorAppToApi = (input: ValidationPhaseError): ApiValidationPhaseError => {
	return {
		...input,
	};
};

export const transformApiAssignmentMoveValidDateRangeToAppAssignmentMoveValidDateRange = (
	input: ApiAssignmentMoveValidDateRangeResponse,
): AssignmentMoveValidDateRangeResponse => {
	return {
		...input,
	};
};

export const transformApiDateRangeToAppDateRange = (input: ApiDateRange): DateRange => {
	return {
		min: new Date(input.min),
		max: new Date(input.max),
	};
};
